var resources = require('itemsViewStrings');
    var strings = resources['_78MbRVIKTzXPBCISF0RjpA'];
export { strings };
export default strings;
